import raterJs from "rater-js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	for (const star of document.querySelectorAll("._readonly-rating-stars")) {
		raterJs({
			starSize: star.dataset.starWidth,
			step: star.dataset.halfStar ? 0.5 : 1,
			readOnly: !!star.dataset.readOnly,
			element: star,
			showToolTip: false,
			rating: Number.parseFloat(star.dataset.rating),
		});
	}
});
